import React, { useContext, useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { ConfigContext } from "../../../../../Base/Context/ConfigContext/ConfigContext";
import { setTitlePage } from "../../../../../Base/Services/Config/ConfigService";
import { getLabel } from "../../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../../Base/Lang/BaseLang";
import Card from "../../../../../Base/Components/Card/Card";
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import {
  getMarcas,
  getTipoDispositivos,
} from "../../../../../API/IT/Dispositivos/DispositivosRequest";
import MarcasScreen from "./Marcas/MarcasScreen";
import MarcasCRUD from "./Marcas/MarcasCRUD";
import TipoDispositivosScreen from "./TipoDispositivos/TipoDispositivosScreen";
import TipoDispositivoCRUD from "./TipoDispositivos/TipoDispositivoCRUD";

const TabMaestrosScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);

  const [activeIndex, setActiveIndex] = useState(0);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(true);
  const [marcas, setMarcas] = useState([]);
  const [tipoDispositivos, setTipoDispositivos] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogTD, setShowDialogTD] = useState(false);

  const getInfo = async () => {
    setLoading(true);
    if (activeIndex === 0) {
      const a = await getMarcas();
      setMarcas(a);
    } else if (activeIndex === 1) {
      const td = await getTipoDispositivos();
      setTipoDispositivos(td);
    }
    setLoading(false);
  };

  const openCrud = async () => {
    setLoading(true);
    if (activeIndex === 0) {
      setShowDialog(true);
      setSelected(null);
    } else if (activeIndex === 1) {
      setShowDialogTD(true);
      setSelected(null);
    }
    setLoading(false);
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "Maestros", config.language));
  }, []);

  useEffect(() => {
    getInfo();
  }, [activeIndex]);
  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />

      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "Maestros", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button icon="pi pi-plus" severity="success" onClick={openCrud} />
          </div>
        }
        contenido={
          <TabView
            style={{ marginTop: "30px" }}
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
          >
            <TabPanel header={"Marca Dispositivos"}>
              <div style={{ height: "82vh" }}>
                <MarcasScreen
                  marcas={marcas}
                  setSelected={setSelected}
                  loading={loading}
                  setShowDialog={setShowDialog}
                />
              </div>
            </TabPanel>

            <TabPanel header={"Tipo Dispositivos"}>
              <div style={{ height: "84vh" }}>
                <TipoDispositivosScreen
                  listTipos={tipoDispositivos}
                  setSelected={setSelected}
                  loading={loading}
                  setShowDialog={setShowDialogTD}
                />
              </div>
            </TabPanel>
          </TabView>
        }
      />

      {showDialog && (
        <MarcasCRUD
          listMarcas={marcas}
          showDialog={showDialog}
          marca={selected}
          setShowDialog={setShowDialog}
          getInfo={getInfo}
        />
      )}

      {showDialogTD && (
        <TipoDispositivoCRUD
          listTipo={tipoDispositivos}
          showDialog={showDialogTD}
          tipoDispositivo={selected}
          setShowDialog={setShowDialogTD}
          getInfo={getInfo}
        />
      )}
    </div>
  );
};

export default TabMaestrosScreen;
